const e = {
  code: "nl",
  facebook: "nl_NL",
  label: "Nederlands",
  loadingText: "Laden...",
  translations: {
    ar: "Arabisch",
    de: "Duits",
    en: "Engels",
    es: "Spaans",
    fr: "Frans",
    he: "Hebreeuws",
    hi: "Hindi",
    id: "Indonesisch",
    it: "Italiaans",
    ja: "Japans",
    km: "Khmer",
    ko: "Koreaans",
    lo: "Laotiaans",
    ms: "Maleis",
    nl: "Nederlands",
    pt: "Portugees",
    ru: "Russisch",
    th: "Thais",
    tl: "Filipijns",
    tr: "Turks",
    vi: "Vietnamees",
    "zh-CN": "Chinees (Vereenv.)",
    "zh-TW": "Chinees (Trad.)"
  }
};
export {
  e as dutch
};
